<template>
  <page class="stakeoutshipment-app">
    <nav-bar slot="header"></nav-bar>
    <page-content slot="content">
      <page-bar v-if="isPrint">
        <page-bar-item :label="$route.meta.label"></page-bar-item>
      </page-bar>
      <portlet class="form-query" hide-title="true">
        <slot name="title"></slot>
        <base-title v-if="isPrint" title="当前自评表"></base-title>
        <el-row style="margin-bottom: 20px;">
          <el-col :span="18">
            <el-col :span="12">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.evaluationNo"
                label="自评表编号"
              ></base-string>
            </el-col>
            <el-col :span="12">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.materialCode"
                label="款号"
              ></base-string>
            </el-col>
            <el-col :span="12">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.relatedMaterialCode"
                label="物料号"
              ></base-string>
            </el-col>
            <el-col :span="12">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.materialDesc"
                label="组件名称"
              ></base-string>
            </el-col>
            <el-col :span="12">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.categoryValue"
                label="类型"
              ></base-string>
            </el-col>
            <el-col :span="12">
              <base-string
                :read-only="inputConfig.readOnly"
                v-model="source.vendorName"
                label="供应商"
              ></base-string>
            </el-col>
          </el-col>
          <el-col :span="6">
            <div class="selfevaluation-check__img">
              <img :src="source.imgUrl" alt />
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="18">
            <base-string
              v-model="source.remark"
              :disabled="true"
              :read-only="true"
              :rows="4"
              type="textarea"
              label="审核意见"
            ></base-string>
          </el-col>
        </el-row>

        <div class="selfevaluation-check__list">
          <div class="selfevaluation-check__list-item">
            <p>此工艺：</p>
            <base-checkbox
              :multiple="true"
              :read-only="pageType <= 2?true:false"
              :options="globalEnum.technicList"
              v-model="source.technic"
            ></base-checkbox>
          </div>
          <div class="selfevaluation-check__list-item">
            <p>此面料不可承担之成衣加工工艺及洗涤方法：</p>
            <base-checkbox
              :multiple="true"
              :read-only="pageType <= 2?true:false"
              :options="globalEnum.washTechnicList"
              v-model="source.washTechnic"
            ></base-checkbox>
          </div>
          <div class="selfevaluation-check__list-item">
            <p>在生产成衣过程中可能发生之质量问题/风险：</p>
            <el-row>
              <el-col :span="24">
                <template v-if="pageType <= 2">
                  <base-string :read-only="true" v-model="source.risk" label :style-type="2"></base-string>
                </template>
                <template v-else>
                  <base-string v-model="source.risk" label></base-string>
                </template>
              </el-col>
            </el-row>
          </div>
          <div class="selfevaluation-check__list-item">
            <p>建议洗涤方式：</p>
            <el-row>
              <el-col :span="24">
                <template v-if="pageType <= 2">
                  <base-string :read-only="true" v-model="source.washingMethod" label></base-string>
                </template>
                <template v-else>
                  <base-string v-model="source.washingMethod" label></base-string>
                </template>
              </el-col>
            </el-row>
          </div>
        </div>

        <base-title title="材料"></base-title>
        <el-table
          v-if="!source.materialFlag"
          :data="source.fabricList"
          border
          style="margin-top: 10px"
          stripe
        >
          <el-table-column
            :show-overflow-tooltip="true"
            property="materialDesc"
            label="物料名称"
            :min-width="200"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="spec"
            label="规格"
            :min-width="100"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="component"
            label="成分"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="unit"
            label="单位"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="noneTaxPrice"
            label="单价"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="consumption"
            label="用量"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="loss"
            label="损耗（%）"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="quote"
            label="报价"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="remarks"
            label="备注（注厂供还是我司供）"
            :min-width="150"
          ></el-table-column>
        </el-table>
        <el-table v-else :data="source.materialList" border style="margin-top: 10px" stripe>
          <!-- <el-table-column
            :show-overflow-tooltip="true"
            property="component"
            label="序号"
            :min-width="200"
          >
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column> -->
          <el-table-column
            :show-overflow-tooltip="true"
            property="materialDesc"
            label="面料名称"
            :min-width="100"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="component"
            label="成分"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="weight"
            label="成品重量(KG)"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="spec"
            label="纱支规格"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="loss"
            label="损耗/KG（%）"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="price"
            label="纱线单价/KG"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="singlePrice"
            label="单件纱价"
            :min-width="150"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            property="remarks"
            label="备注"
            :min-width="150"
          ></el-table-column>
        </el-table>

        <el-row type="flex" style="margin-bottom: 10px;">
          <el-table :data="source.itemList" border style="margin-top: 10px" stripe>
            <el-table-column
              :show-overflow-tooltip="true"
              property="nationalInspectionName"
              label="国家检验项目"
              :min-width="200"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="inspectionCategory"
              label="检验类"
              :min-width="70"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="inspection"
              label="是否必填"
              :min-width="80"
            >
              <template scope="scope">
                <base-select
                  style-type="2"
                  :read-only="true"
                  :label-width="0"
                  v-model="scope.row.inspection"
                  apiName="POST_SPS_SYS_ENUM_URL"
                  :params="{typeCode: 'IsNeedOrNot'}"
                  placeholder
                ></base-select>
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="firstStandard"
              label="一等品标准"
              :min-width="200"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="productStandard"
              label="合格品标准"
              :min-width="200"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="inspectionExplain"
              label="检验说明"
              :min-width="100"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              property="selfAchievableDegree"
              label="供应商自估可达到程度"
              :min-width="150"
            >
            </el-table-column>
          </el-table>
        </el-row>
      </portlet>
    </page-content>
  </page>
</template>
<script>
import baseString from "components/base-control/modules/base-string.vue";
import baseCheckbox from "components/base-control/modules/base-checkbox.vue";
import baseSelect from "components/base-control/modules/base-select.vue";
import * as globalEnum from "src/common/global-enum";
// import { parseImgUrlProductImg } from "src/filter/modules/img";
export default {
  name: "selfevaluation-check",
  props: {
    type: {
      type: [String, Number],
      default: 1
    },
    isPrint: {
      type: Boolean,
      default: false
    }
  },
  components: {
    baseString,
    baseCheckbox,
    baseSelect
  },
  filters: {
    // parseImgUrlProductImg
  },
  computed: {
    isSuppler() {
      if (!this.$store.getters && !this.$store.getters.userType) return false;
      const userType = this.$store.getters.userType;
      if (userType >= 3) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleUpdate() {
      this.$apis.selfevaluation
        .EVALUATION_LOG_UPDATE({
          quoteId: this.$route.query.quoteId,
          itemList: this.source.itemList,
          evaluationId: this.source.evaluationId,
          washingMethod: this.source.washingMethod,
          risk: this.source.risk,
          technic: JSON.stringify(this.source.technic.map(item => item.code)),
          washTechnic: JSON.stringify(
            this.source.washTechnic.map(item => item.code)
          )
        })
        .done(res => {
          this.$message({
            type: "success",
            message: "提交成功"
          });
          this.handleBack();
        })
        .fail(err => {
          this.$message({
            type: "error",
            message: err.message
          });
        });
    },
    EVALUATION_LOG_DETAIL() {
      this.$apis.autoAPi
        .EVALUATION_LOG_DETAIL({
          id: this.$route.query.id
        })
        .done(res => {
          this.source = res.data;
          this.source.washTechnic = formatWashTechnic(
            globalEnum.washTechnicList,
            this.source.washTechnic
          );
          this.source.technic = formatWashTechnic(
            globalEnum.technicList,
            this.source.technic
          );
          function formatWashTechnic(keyList, source) {
            const array = JSON.parse(source);
            return keyList.reduce((pre, next) => {
              const i = array.findIndex(item => item == next.code);
              if (i > -1) pre.push(next);
              return pre;
            }, []);
          }
        })
        .fail(err => {});
    },
    EVALUATION_LOG_CHECK(type) {
      return new Promise((resolve, reject) => {
        // 审核状态：0：未审核，1：已审核
        this.$apis.selfevaluation
          .EVALUATION_LOG_CHECK({
            // evaluationId: this.$route.query.id,
            quoteId: this.$route.query.quoteId,
            checkStatus: type,
            remark: this.source.remark,
            materialCode: this.source.materialCode
          })
          .done(res => {
            resolve(res);
          })
          .fail(err => {
            reject(err);
          });
      });
    },
    handleCheckInfo(type) {
      let text;
      if (type == 1) text = "审核";
      if (type == 2) text = "退回";

      this.$confirm("确定标记为" + text + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return this.EVALUATION_LOG_CHECK(type);
        })
        .then(res => {
          this.$message({
            type: "success",
            message: res.message || "操作成功"
          });
          this.handleBack();
        })
        .catch(err => {
          // this.$message({
          //     type: 'error',
          //     message: err.message || '操作失败'
          // });
        });
    },
    handleCancel() {
      this.$router.push({
        path: "review",
        query: {
          id: this.$route.id,
          pageType: 2
        }
      });
    },
    handleBack() {
      this.$router.push({
        path: "/selfevaluation/manager"
      });
    },
    setSource(source) {
      this.source = source;
    }
  },
  mounted() {
    // if (!this.isPrint) {
    this.EVALUATION_LOG_DETAIL();
    // }
  },
  data() {
    return {
      pageType: 2,
      list: [],
      globalEnum,
      source: {
        itemList: []
      },
      inputConfig: {
        readOnly: true
      }
    };
  }
};
</script>

<style scoped lang="scss">
.selfevaluation-check__list-item {
  margin-bottom: 10px;
}
.selfevaluation-check__img {
  border: 1px solid #ddd;
  img {
    max-width: 300px;
    max-height: 400px;
  }
}
</style>
